// extracted by mini-css-extract-plugin
export default {"faqSection":"FaqSection_faqSection__EG+-a","faqText":"FaqSection_faqText__kdl26","accordion":"FaqSection_accordion__F6w4+"};